import React, { useState ,useEffect} from 'react'
import { Collapse, Tabs, Panel } from "antd";
import './tnx-payment-details.scss';
import backArrow from '../../../assets/images/arrow-left-back.svg';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import TnxOrderDetails from './tnx-order-details';


const TnxPaymentDetails = () => {
     const navigate = useNavigate();
     const { Panel } = Collapse;
     const [activeKey, setActiveKey] = useState(null);
     const [transactionIds, setTransactonIds] = useState([
      { orderId: "ORD0089839", amountReceived: "AED 1,200" },
      { orderId: "ORD0089840", amountReceived: "AED 1,500" },
      { orderId: "ORD0089841", amountReceived: "AED 900" },
    ])

     const handleCollapseChange = (key) => {
      setActiveKey(key);
    };



    return (
      <div className='tnx-payment-card-container'>
       <div className='transaction-id'>
                <img src={backArrow} alt='backIcon'   style={{ cursor: "pointer" }}
                      onClick={() => navigate("/earnings", { state: { activeTab: "transaction" } })} />
                <span style={{ marginLeft: "10px", fontWeight: 700, fontSize: "20px" , color: "var(--text, #000000)" }}>
                    {"#FT23240009826"}
                </span>
            </div>

            {transactionIds.map((order, index) => (
                   <Collapse
                      className='section-collapse'
                      accordion={true}
                      collapsible="header"
                      expandIconPosition={"end"}
                      destroyInactivePanel={true}
                      onChange={handleCollapseChange}
                   
                  >
                    <Panel
                      className="collapse-panel"
                      header={
                        <div className="panel-header">
                          <span>Order ID : {order.orderId}</span>
                          <span className='amt-value'>
                            Amt Received: <span style={{color: "var(--text, #1A234B)"}}>{order.amountReceived}</span>
                          </span>
                        </div>
                      }
                      key={index}
                    >
                      <p>Panel content for {order.orderId} goes here.</p>
                    </Panel>
                </Collapse>
                  ))}
       </div>
    );
  };

export default TnxPaymentDetails;